import {
  ContentStates,
  type ContentStateEnum,
} from '../../enums/ContentStateEnum'

interface IContentStateInput {
  hasSubmittedQuery: boolean
  hasRecentItems: boolean
  isSearchLoading: boolean
  hasResultItems: boolean
  isSearchSuccess: boolean
  isUnsupportedQuery: boolean
  isSearchError: boolean
}

export function deriveContentState(
  input: IContentStateInput
): Nullable<ContentStateEnum> {
  if (!input.hasSubmittedQuery && input.hasRecentItems) {
    return ContentStates.RECENTS
  }
  if (input.isSearchLoading) {
    return ContentStates.LOADING
  }
  if (input.hasSubmittedQuery && input.hasResultItems) {
    return ContentStates.RESULTS
  }
  if (
    input.hasSubmittedQuery &&
    input.isSearchSuccess &&
    !input.hasResultItems &&
    input.isUnsupportedQuery
  ) {
    return ContentStates.UNSUPPORTED_QUERY
  }
  if (
    input.hasSubmittedQuery &&
    input.isSearchSuccess &&
    !input.hasResultItems &&
    !input.isUnsupportedQuery
  ) {
    return ContentStates.EMPTY
  }
  if (input.hasSubmittedQuery && input.isSearchError) {
    return ContentStates.ERROR
  }
  return null
}
